import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { useIdleTimer } from './useIdleTimerContext';
import { fetchStationData } from '../fetchDataFromStrapi';

function normalizeKey(e) {
  const m = /^Digit([0-9])$/.exec(e.code);
  return m ? m[1] : null;
}

export default function GlobalKeyboardHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetIdleTimer } = useIdleTimer();
  const [stations, setStations] = useState([]);
  const [cooldown, setCooldown] = useState(false);

  useEffect(() => {
    (async () => {
      const data = await fetchStationData();
      setStations(data);
    })();
  }, []);

  const extractStationFromPath = (pathname) => pathname.split('/')[1];

  const getCurrentStation = useCallback(
    (stationName) => stations.find((station) => station.slug === stationName),
    [stations],
  );

  const navigateToScreensaver = useCallback(
    (key) => {
      const screensaverRoutes = {
        '1': '/bohren',
        '2': '/tragen',
        '3': '/ziehen',
      };
      if (screensaverRoutes[key]) navigate(screensaverRoutes[key]);
    },
    [navigate],
  );

  const navigateToButtonPage = useCallback(
    (key, station, maxButtons) => {
      if (!maxButtons) return;
      const k = Number(key);
 
      if (k >= 1 && k <= Number(maxButtons)) {
        navigate(`/${station}/taste${k}`);
      }
    },
    [navigate],
  );

  const handleNavigation = useCallback(
    (key, pathname) => {
      if (pathname.startsWith('/quiz')) return;

      if (pathname === '/') {
        navigateToScreensaver(key);
        return;
      }

      const station = extractStationFromPath(pathname);
      const currentStation = getCurrentStation(station);
      if (!currentStation) return;

      const maxButtons = currentStation.buttonCount;

      if (pathname.includes('/startseite')) {
        navigateToButtonPage(key, station, maxButtons);
      } else if (pathname.includes('/taste')) {
        if (key === '0') navigate(`/${station}/startseite`);
      } else {
        navigate(`/${station}/startseite`);
      }
    },
    [getCurrentStation, navigateToScreensaver, navigateToButtonPage, navigate],
  );

  const activateCooldown = () => {
    setCooldown(true);
    setTimeout(() => setCooldown(false), 2000);
  };

  const handleKeyPress = useCallback(
    (event) => {
      if (cooldown) return;

      const key = normalizeKey(event);

      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
        event.preventDefault();
      }

      resetIdleTimer();
      handleNavigation(key, location.pathname);
      activateCooldown();
    },
    [location.pathname, cooldown, resetIdleTimer, handleNavigation],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress, { passive: false });
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress]);

  return null;
}
